const cryptocurrency = {
  paymentMethodName: 'Criptomoneda',
  cryptocurrencyLabel: 'Criptomoneda',
  cryptocurrencySelectPlaceholder: 'Selecciona tu criptomoneda',
  protocolWarning: 'Si el pago se realiza usando una red diferente a la seleccionada, los fondos pueden perderse permanentemente. <b>Asegúrate de que tu billetera digital esté configurada para la red correcta</b> antes de continuar.',
  networkLabel: 'Red',
  networkSelectPlaceholder: 'Selecciona tu red',
  paymentButtonLabel: 'Pagar con Criptomoneda',
  amountLocal: 'Monto local',
  amountCrypto: 'Monto en cripto',
  paymentCreatedTitle: '¡Tu pago se ha generado!',
  paymentCreatedSubtitle: '¡No tardará mucho en completarse tu pedido! Sigue las instrucciones a continuación para confirmar esta transacción:',
  qrCodeInstruction: 'Escanea el siguiente código QR en tu billetera digital para proceder con el pago.',
  qrCodeNetworkNotFound: 'Red no encontrada. Asegúrate de haber seleccionado la red correcta.',
  networkWarning: 'Estás pagando <b>{cryptocurrency}</b> usando la red <b>{protocol}</b>. Asegúrate de seleccionar la red correcta en tu billetera digital; de lo contrario, tus fondos pueden perderse.',
  conversionRate: 'Para tu referencia: 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}.',
  paymentApproved: 'Tu pago de <AmountText>{amountLocal}</AmountText> fue aprobado.',
  howToPayInfoTitle: '¿Cómo pagar con cripto?',
  howToPayOpenApp: 'Abre tu billetera (aplicación o extensión) y selecciona Comprar, Transferir, Enviar o Pagar.',
  howToPayQrCode: 'Escanea el código QR o copia y pega los campos requeridos en tu billetera.',
  howToPayNetwork: 'Asegúrate de seleccionar la red correcta. Si seleccionas la incorrecta, los fondos podrían no ser recuperables.',
  howToPayConfirmation: 'Revisa el estado en tu billetera digital (Actividad/Historial) o regresa a esta página para esperar la confirmación.',
  payAgreement1: 'Al continuar, aceptas los ',
  serviceTerms: 'Términos y Condiciones',
  payAgreement2: ' de EBANX.',

};

module.exports = cryptocurrency;
